import {Dispatch} from 'redux';

import {axiosService} from '../../services';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {AppActions} from '../../types';

export const onTourGetTrack = (tourId: any) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const res = await axiosService.tourGetTrack(tourId);
      dispatch(fetchSuccess());
      return Promise.resolve(res);
    } catch (err: any) {
      dispatch(fetchError(err));
    }
  };
};

export const onTourGetAssignees = () => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const res = await axiosService.tourGetAssignees();
      dispatch(fetchSuccess());
      return Promise.resolve(res);
    } catch (err: any) {
      dispatch(fetchError(err));
    }
  };
};

export const onTourAssign = (tourId: any, driverId: any) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const res = await axiosService.tourAssign(tourId, driverId);
      dispatch(fetchSuccess());
      return Promise.resolve(res);
    } catch (err: any) {
      dispatch(fetchError(err));
    }
  };
};

export const tourChangeStatus = (
  tourId: any,
  statusId: number,
  billOfLadding: File | null = null,
  proofOfDelivery: File | null = null,
  shouldChangeStatus: boolean,
) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const res = await axiosService.tourChangeStatus(
        tourId,
        statusId,
        billOfLadding,
        proofOfDelivery,
        shouldChangeStatus,
      );
      dispatch(fetchSuccess());
      return Promise.resolve(res);
    } catch (err: any) {
      dispatch(fetchError(err));
    }
  };
};

export const onTourGetToken = (expirationSeconds: number, tourId: string) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const res = await axiosService.tourGetToken(expirationSeconds, tourId);

      dispatch(fetchSuccess());
      return Promise.resolve(res);
    } catch (err: any) {
      dispatch(fetchError(err));
    }
  };
};

export const onTourGetPublicTrackData = (token: string) => {
  return async (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      const res = await axiosService.tourGetPublicTrackData(token);
      dispatch(fetchSuccess());
      return Promise.resolve(res);
    } catch (err: any) {
      dispatch(fetchError(err));
    }
  };
};
